import { Component, Inject, InjectionToken, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IOperationOverlaySmallDialogData } from '../operation-overlay-small.service';

export const OPERATION_OVERLAY_SMALL_CONTENT_DATA = new InjectionToken<any>('OperationOverlaySmallContentData');

@Component({
    selector: 'fi-operation-overlay-small-dialog',
    template: `
        <div class="operation-overlay-small">
            <ng-container *ngComponentOutlet="contentComponent; injector: contentInjector"></ng-container>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./operation-overlay-small-dialog.component.scss'],
    standalone: false,
})
export class OperationOverlaySmallDialogComponent implements OnInit {
    contentComponent;
    contentInjector: Injector;

    constructor(
        @Inject(MAT_DIALOG_DATA) dialogData: IOperationOverlaySmallDialogData,
        private dialogRef: MatDialogRef<OperationOverlaySmallDialogComponent>,
        injector: Injector,
    ) {
        this.contentComponent = dialogData.contentData.component;
        this.contentInjector = Injector.create({
            providers: [{ provide: OPERATION_OVERLAY_SMALL_CONTENT_DATA, useValue: dialogData }],
            parent: injector,
        });
    }

    ngOnInit() {}
}
